export const CONFIG = 'CONFIG'
export const RESET = 'RESET'
export const INFORMATION_RETURN_TIMEOUT = 10000
export const PROBLEM_SOLVED_AVAILABILITY_STATUS = 'INCIDENTE_TRATATIVA_REALIZADA'
export const OSM = 'OSM'
export const SOM = 'SOM'
export const PEOPLE = 'PEOPLE'

export const ServiceOrderDescriptionTranslations = {
  'NOTIFICACAO_M1': 'MSG_0357',
  'NOTIFICACAO_M2': 'MSG_0358',
  'NOTIFICACAO_M3': 'MSG_0359',
  'NOTIFICACAO_M4': 'MSG_0360',
  'BLOQUEADO': 'MSG_0361',
  'DESBLOQUEADO': 'MSG_0362',
  'INCIDENTE_TRATATIVA_INICIADA': 'MSG_0363',
  'INCIDENTE_TRATATIVA_IMPROCEDENTE': 'MSG_0364',
  'INCIDENTE_TRATATIVA_REALIZADA': 'MSG_0365',
  'INCIDENTE_NAO_ACEITO': 'MSG_0366',
  'INCIDENTE_ACEITO': 'MSG_0367',
  'VISITA_CONCLUIDA': 'MSG_0368',
  'PORTABILIDADE_REVISADA': 'MSG_0369',
}

export const INCIDENT_VOICE_DESCRIPTION = [
  {
      id: 'eco',
      label: 'Eco',
      checked: true,
      value: 'Eco'
  },
  {   
      id: 'ruido',
      label: 'Ruído',
      checked: true,
      value: 'Ruído'
  },
  {   
      id: 'picote',
      label: 'Picote',
      checked: true,
      value: 'Picote'
  }
]

export const THE_FAILURE_AFFECTS = [
    {
        label: 'um Número',
        value: 'um Número'
    },
    {
        label: 'uma localidade',
        value: 'uma localidade'
    },
    {
        label: 'Todas as ligações',
        value: 'Todas as ligações'
    }
]


// WEBPACK FOOTER //
// ./src/services/state/repair/constants.js